import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_PREVIOUSSOS,
  FETCH_PREVIOUSSOS_SUCCESS,
  FETCH_PREVIOUSSOS_FAILURE,
  REQUEST_PREVIOUSORDERS,
  REQUEST_PREVIOUSSO_DETAIL,
  FETCH_PREVIOUSSO_DETAIL_SUCCESS,
  FETCH_PREVIOUSSO_DETAIL_FAILURE,
  FETCH_PREVIOUSORDERS_SUCCESS,
  FETCH_PREVIOUSORDERS_FAILURE,
  SELECT_PREVIOUSORDERS,
  RESET_CURRENT_PREVIOUSORDERS,
  REQUEST_PREVIOUSORDERS_DETAIL,
  FETCH_PREVIOUSORDERS_DETAIL_SUCCESS,
  FETCH_PREVIOUSORDERS_DETAIL_FAILURE,
  REQUEST_ADDING_PREVIOUSORDER,
  ADD_PREVIOUSORDER_SUCCESS,
  ADD_PREVIOUSORDER_FAILURE,
  REQUEST_DELETE_PREVIOUSORDER,
  DELETE_PREVIOUSORDER_SUCCESS,
  DELETE_PREVIOUSORDER_FAILURE, REQUEST_PREVIOUSSQS, FETCH_PREVIOUSSQS_SUCCESS, FETCH_PREVIOUSSQS_FAILURE, FETCH_PREVIOUSSQ_DETAIL_SUCCESS, FETCH_PREVIOUSSQ_DETAIL_FAILURE, REQUEST_PREVIOUSSQ_DETAIL,
} from '../actions/type';

import { PREVIOUSORDERS_URL, SALES_ORDERS_URL, FETCH_INVOICE_DETAIL_URL, SALES_QUOTE_URL } from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI, isOLG } from './root_url'
// Inventories Actions

export function fetchPreviousOrdersSuccess(previousOrders) {
  return {
    type: FETCH_PREVIOUSORDERS_SUCCESS,
    payload: previousOrders,
  };
}

export function fetchPreviousOrdersFailure(error) {
  return {
    type: FETCH_PREVIOUSORDERS_FAILURE,
    payload: error,
  };
}

export function fetchPreviousOrders(customerID, fromDate, toDate) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSORDERS });
    const dates = toFromDates(-1, fromDate, toDate);
    return axios.get(
      PREVIOUSORDERS_URL + customerID + '?StartDate=' + dates.fromDate + '&EndDate=' + dates.toDate,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPreviousOrdersFailure(err));               
        }
      });
  };
}

// Fetch previous sales order
export function fetchPreviousSOsSuccess(previousSOs) {
  return {
    type: FETCH_PREVIOUSSOS_SUCCESS,
    payload: previousSOs,
  };
}

export function fetchPreviousSOsFailure(error) {
  return {
    type: FETCH_PREVIOUSSOS_FAILURE,
    payload: error,
  };
}
// Fetch previous sales quote
export function fetchPreviousSQsSuccess(previousSQs) {
  return {
    type: FETCH_PREVIOUSSQS_SUCCESS,
    payload: previousSQs,
  };
}

export function fetchPreviousSQsFailure(error) {
  return {
    type: FETCH_PREVIOUSSQS_FAILURE,
    payload: error,
  };
}
export function fetchPreviousSalesOrderByCustomer(customerId, postingDateGT, postingDateLT, olongFlag) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSOS });
    // default 90 days
    const days = 90;
    const dates = toFromDates(days, postingDateGT, postingDateLT);
    let previousOrderParam = olongFlag ? 'previous_orders' : 'search/'
    let url = `${SALES_ORDERS_URL}${previousOrderParam}?Deliver_Customer_id=${customerId}&OrderDate__gte=${dates.fromDate}&OrderDate__lte=${dates.toDate}`
    if(isGGI) {
      url += '&noCancel=true'
    }
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousSOsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPreviousSOsFailure(err));               
        }
      });
  };
}

export function fetchPreviousSalesQuotes(postingDateGT, postingDateLT) {
  return dispatch => {
    dispatch({ type: REQUEST_PREVIOUSSQS });
    const days = 90;
    const dates = toFromDates(days, postingDateGT, postingDateLT);
    // let url = `${SALES_QUOTE_URL}search/?OrderDate__gte=${dates.fromDate}&OrderDate__lte=${dates.toDate}`
    let url = `${SALES_QUOTE_URL}search/`;
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousSQsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPreviousSQsFailure(err));
        }
      });
  }
}

export function fetchSalesOrderDetailSuccess(salesOrderDetail) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_SUCCESS,
    payload: salesOrderDetail,
  };
}

export function fetchSalesOrderDetailFailure(error) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchSalesQuoteDetailSuccess(salesQuoteDetail) {
  return {
    type: FETCH_PREVIOUSSQ_DETAIL_SUCCESS,
    payload: salesQuoteDetail,
  };
}

export function fetchSalesQuoteDetailFailure(error) {
  return {
    type: FETCH_PREVIOUSSQ_DETAIL_FAILURE,
    payload: error,
  };
}

// Fetch products from all previous sales order
export function fetchPreviousOrdersFromALLSOsSuccess(products) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_SUCCESS,
    payload: products,
  };
}
export function fetchPreviousOrdersFromALLSOsFailure(error) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchPreviousOrdersFromALLSalesOrder(customerId, postingDateGT, postingDateLT) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSO_DETAIL });
    // default 90 days
    const days = 90;
    const dates = toFromDates(days, postingDateGT, postingDateLT);
    return axios.get(
      `${SALES_ORDERS_URL}previous_date?Deliver_Customer_id=${customerId}&OrderDate__gte=${dates.fromDate}&OrderDate__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousOrdersFromALLSOsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPreviousOrdersFromALLSOsFailure(err));               
        }
      });
  };
}

// Fetch SO from select search
export function fetchPreviousOrderBySearchSuccess(salesOrderDetail) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_SUCCESS,
    payload: salesOrderDetail,
  };
}
export function fetchPreviousOrderBySearchFailure(error) {
  return {
    type: FETCH_PREVIOUSSO_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchPreviousOrderBySearch(SONum, olongFlag) {
  return (dispatch) => {
    let numParam = olongFlag ? 'InvoiceNum' : 'SONum'
    dispatch({ type: REQUEST_PREVIOUSSO_DETAIL });
    return axios.get(
      `${SALES_ORDERS_URL}?${numParam}=${SONum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        if (isOLG) {
          dispatch(fetchPreviousSOsSuccess({...response, data: response.data.Orders}));
        } else {
          dispatch(fetchPreviousOrderBySearchSuccess(response));
        }
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPreviousOrderBySearchFailure(err));               
        }
      });
  };
}
export function fetchPreviousQuoteBySearchSuccess(salesQuoteDetail) {
  return {
    type: FETCH_PREVIOUSSQ_DETAIL_SUCCESS,
    payload: salesQuoteDetail,
  };
}
export function fetchPreviousQuoteBySearchFailure(error) {
  return {
    type: FETCH_PREVIOUSSQ_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchPreviousQuoteBySearch(SQNum, Company_id, Warehouse_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSQ_DETAIL });
    return axios.get(
      `${SALES_QUOTE_URL}?SQNum=${SQNum}${Company_id ? `&Company_id=${Company_id}` : ''}${Warehouse_id ? `&Warehouse_id=${Warehouse_id}` : ''}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPreviousQuoteBySearchSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPreviousQuoteBySearchFailure(err));
        }
      });
  };
}

// Fetch products from select sales order
export function fetchPreviousOrderById(salesOrder_id, Company_id = '', Warehouse_id = '', olongFlag) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSO_DETAIL });
    let otherParams = '';
    if (Company_id) {
        otherParams += `&Company_id=${Company_id}`;
    }
    if (Warehouse_id) {
        otherParams += `&Warehouse_id=${Warehouse_id}`;
    }
    let soDetailUrl = olongFlag ? FETCH_INVOICE_DETAIL_URL : `${SALES_ORDERS_URL}?pk=`
    return axios.get(
      `${soDetailUrl}${salesOrder_id}${otherParams}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSalesOrderDetailFailure(err));               
        }
      });
  };
}

// Fetch products from select sales quote
export function fetchPreviousQuoteById(salesQuote_id, Company_id = '', Warehouse_id = '') {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSSQ_DETAIL });
    let otherParams = '';
    if (Company_id) {
      otherParams += `&Company_id=${Company_id}`;
    }
    if (Warehouse_id) {
      otherParams += `&Warehouse_id=${Warehouse_id}`;
    }
    return axios.get(
      `${SALES_QUOTE_URL}?pk=${salesQuote_id}${otherParams}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesQuoteDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSalesQuoteDetailFailure(err));
        }
      });
  };
}

export function fetchPreviousSalesOrderByIndexFromLast(customerId, indexFromLast) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PREVIOUSORDERS });
    return axios({
      method: 'GET',
      url: `${PREVIOUSORDERS_URL}${customerId}/${indexFromLast}`,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    }).then((response) => {
      dispatch(fetchPreviousOrdersSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchPreviousOrdersFailure(err));             
      }
    });
  };
}

export function selectPreviousOrders(previousOrders) {
    return {
        type: SELECT_PREVIOUSORDERS,
        payload: previousOrders
    };
}

export function resetCurrentPreviousOrders() {
    return {
        type: RESET_CURRENT_PREVIOUSORDERS
    }
}


export function fetchPreviousOrdersDetail(previousOrders_id) {
    return dispatch => {
        dispatch({ type: REQUEST_PREVIOUSORDERS_DETAIL });
        return axios.get(PREVIOUSORDERS_URL + previousOrders_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchPreviousOrdersDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchPreviousOrdersDetailFailure(err));                     
              }
            });
    }
}

export function fetchPreviousOrdersDetailSuccess(previousOrdersDetail) {
    return {
        type: FETCH_PREVIOUSORDERS_DETAIL_SUCCESS,
        payload: previousOrdersDetail
    };
}

export function fetchPreviousOrdersDetailFailure(error) {
    return {
        type: FETCH_PREVIOUSORDERS_DETAIL_FAILURE,
        payload: error
    };
}

export function addNewPreviousOrder({
    Product_id,
    ProductNum,
    RefNum,
    ProductName,
    PreSale,
    InStock,
    Ordered,
    Price
}) {
  return dispatch => {
      dispatch({ type: REQUEST_ADDING_PREVIOUSORDER });
      axios.post(PREVIOUSORDERS_URL,
          {
              Product_id,
              ProductNum,
              RefNum,
              ProductName,
              PreSale,
              InStock,
              Ordered,
              Price
          },
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(addPreviousOrderSuccess());
          }, err => {
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
              document.getElementById('tokenInvalid').style.display = 'flex'
            } else {
              dispatch(addPreviousOrderFailure(err));                   
            }
          });
  }
}

export function addPreviousOrderSuccess() {
    return {
      type: ADD_PREVIOUSORDER_SUCCESS,
    }
}

export function addPreviousOrderFailure(response) {
    return {
      type: ADD_PREVIOUSORDER_FAILURE,
      payload: response
    }
}

export function deletePreviousOrder(Product_id) {
  return dispatch => {
      dispatch({ type: REQUEST_DELETE_PREVIOUSORDER });
      axios.delete(PREVIOUSORDERS_URL + Product_id,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      )
      .then(response => {
        dispatch(deletePreviousOrderSuccess());
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deletePreviousOrderFailure());               
        }
      });
  }
}

export function deletePreviousOrderSuccess() {
    return {
      type: DELETE_PREVIOUSORDER_SUCCESS,
    }
}

export function deletePreviousOrderFailure(response) {
    return {
      type: DELETE_PREVIOUSORDER_FAILURE,
      payload: response
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/previousOrders_actions.jsx